import { Controller } from 'react-hook-form';

import useCreateNewRoomDataContext from 'modules/CreateNewRoomModal/CreateNewRoomDataProvider/useCreateNewRoomDataContext';

import TimeZoneDropdown from './TimeZoneDropdown';
import { getTimeZones } from './timezones';

const TimeZoneSelect = () => {
  const {
    roomForm: { trigger, control },
  } = useCreateNewRoomDataContext();

  return (
    <Controller
      name="timeZone"
      control={control}
      render={({ field: { onChange, value } }) => {
        let currentTitle = '';

        const timeZoneOptions = getTimeZones().map(({ timezone, title }) => {
          const isSelected = value === timezone;
          const onClick = () => {
            onChange(timezone);
            trigger(['startDate', 'startTime', 'endDate', 'endTime', 'reminders']);
          };

          if (isSelected) currentTitle = title;
          const selectionClassName = isSelected ? 'bg-gray-5' : undefined;

          return { title, isSelected, onClick, selectionClassName };
        });

        return <TimeZoneDropdown options={timeZoneOptions} currentValue={currentTitle} />;
      }}
    />
  );
};

export default TimeZoneSelect;
